export const ASSESSMENTS_SOURCES = ["THRIVE"];
